import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  Container,
  Footer,
  InfoNavbar,
  Plan,
  ProductBenefits,
  ProductCover,
  ProductInformation,
  ProductNotCover,
  ProductRequirements,
} from '../components';
import { useView } from '../hooks';
import { navigate } from '../store/Commons';
import { IPlan, selectedPlan } from '../store/Quote';

interface IMatrixProps {
  fullname: string;
  selectPlan: (payload: IPlan) => void;
  backHome: () => void;
}

export function Matrix(props: IMatrixProps) {
  const { selectPlan } = props;
  const { grid } = useView();

  const plans = [
    {
      accident: '600 diarios hasta por 30 días',
      death: '250,000',
      grid: true,
      plan_id: 'Plan - Titular',
      plan_name: 'Plan de Accidentes Personales - Titular',
      premium: '0,33',
      premium_monthly: 150,
      sickness: '600 diarios hasta por 30 días',
    },
  ];

  useEffect(() => window.scrollTo(0, 0));

  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    const tagManagerArgs = {
      dataLayer: {
        event: 'vpvPaso1',
      },
      dataLayerName: 'datalayer',
    };

    TagManager.dataLayer(tagManagerArgs);
  }

  return (
    <Container>
      <div className="relative">
        <div id="banner" className="w-100" />
        <div className="container mb100">
          <div className="row">
            <div className="col-12">
              <h1 className="text-center mb5 px-37 mb10 mt60">Seguro de Accidentes Personales</h1>
              <h2 className="text-center text-primary mb50 px-22">
                Protégete en caso de accidente o enfermedad
              </h2>
              <div className="row mt50 justify-content-center">
                {plans.map((plan, index) => (
                  <Plan
                    {...plan}
                    key={plan.plan_id}
                    selectPlan={selectPlan}
                    grid={grid}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <InfoNavbar />
      <ProductInformation />
      <div className="d-block d-sm-none mb100" />
      <ProductCover />
      <ProductBenefits />
      <ProductRequirements />
      <ProductNotCover />
      <Footer />
    </Container>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: {
      quote: { plansWithConsultation, plansWithoutConsultation },
    },
  } = state;

  return {
    plansWithConsultation,
    plansWithoutConsultation,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  back: (payload: string) => dispatch(navigate(payload)),
  backHome: () => dispatch(navigate('/')),
  selectPlan: (payload: IPlan) => dispatch(selectedPlan(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Matrix);
